/**
 * RegistrationStepIndustry Component
 */

import { setUserDetail } from '../../../../redux/actions/user';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import Button from '../../../atoms/buttons/Button';
import Heading from '../../../atoms/text/Heading';
import { industries } from './config';

interface IOwnDispatchProps {
  setUserIndustry: (value: string) => void;
}

interface IOwnProps {
  onComplete: () => void;
}

type RegistrationStepIndustryProps = IOwnProps & IOwnDispatchProps;

const classes = new BEM('account-registration');

class RegistrationStepIndustry extends React.Component<RegistrationStepIndustryProps, {}> {

  onClickButton(industry: string) {
    this.props.setUserIndustry(industry);
    setTimeout(this.props.onComplete, 0);
  }

  render() {
    return (
      <div {...classes('step', 'company-type') }>
        <Heading is="h3"  {...classes('step__title') }>What does your company do?</Heading>
        <ul>
          {industries.map(({ id, label }) =>
            <li key={`job-type-${id}`}>
              <Button
                onClick={() => this.onClickButton(id)}
                colorScheme="white"
                label={label}
                size="small"
                {...classes('answer-button') }
              />
            </li>,
          )}
        </ul>
      </div>
    );
  }
}

const ConnectedRegistrationStepIndustry = connect(
  null,
  (dispatch): IOwnDispatchProps => ({
    setUserIndustry: (value) => {
      dispatch(setUserDetail({ key: 'industryId', value }));
    },
  }),
)(RegistrationStepIndustry);

export default ConnectedRegistrationStepIndustry;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Registration/RegistrationStepIndustry.tsx